export default "__VITE_ASSET__DFLMPgso__"